const SUCCESS = 300000
const ERROR = 10000

function isVersionCompatible(current, target) {
  const currentNum = parseInt(current.slice(1).split('.')[0], 10)
  const targetNum = parseInt(target.slice(1).split('.')[0], 10)
  return currentNum >= targetNum
}

export default async () => {
  const handle = async () => {
    const ctx = window.$nuxt
    const again = error => setTimeout(handle, error ? ERROR : SUCCESS)
    const myVersion = window.$versionTag
    if (!myVersion || !navigator.onLine || !ctx?.$route) {
      again(true)
      return
    }
    const query = ctx.$route.query || {}
    const ignoreVersion = 'ignoreVersion' in query
    const retry = query.retry ?? 0
    if (ignoreVersion) {
      ctx.$telemetry.pushEvent({
        category: 'versionControl',
        name: 'update',
        action: 'ignoreVersion',
        retry: retry || null,
      })
      return
    }
    const replaceQuery = params =>
      window.history.replaceState(
        {},
        '',
        `?${new URLSearchParams({ ...query, ...params }).toString()}`
      )
    if (retry >= 4) {
      setTimeout(() => replaceQuery({ ignoreVersion: true }))
      return
    }
    try {
      const response = await ctx.$axios.get('/version/mandatory', {
        ignoreExpiredToken: true,
      })
      const { version } = response.data
      if (!version || isVersionCompatible(myVersion, version)) {
        again()
        return
      }
      ctx.$telemetry.pushEvent({
        category: 'versionControl',
        name: 'update',
        action: 'forceReset',
        retry,
      })
      replaceQuery({ retry: parseInt(retry, 10) + 1 })
      window.location.reload(true)
    } catch (error) {
      ctx.$telemetry.pushEvent({
        category: 'versionControl',
        name: 'update',
        action: 'forceReset',
        error,
        retry,
      })
      again(error)
    }
  }
  await handle()
}
